import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { FtpDataSourceImportJobSettings } from "../../Model/recurringJobs/ftp/ftpDataSourceImportJobSettings";

@Injectable()
export class FtpDataSourceImportJobsService {
  private readonly apiUrl = 'api/FtpDataSourceImportJobs';

  constructor(private http: HttpClient) { }

  public getAll(customerId): Observable<FtpDataSourceImportJobSettings[]> {
    const url = `${this.apiUrl}/GetAll?customerId=${customerId}`;
    return this.http.get<FtpDataSourceImportJobSettings[]>(url);
  }

  public get(id): Observable<FtpDataSourceImportJobSettings> {
    const url = `${this.apiUrl}/Get?id=${id}`;
    return this.http.get<FtpDataSourceImportJobSettings>(url);
  }

  public update(model: FtpDataSourceImportJobSettings, customerId: string): Observable<FtpDataSourceImportJobSettings> {
    const url = `${this.apiUrl}/Update`;
    return this.http.post<FtpDataSourceImportJobSettings>(url, model);
  }

  public delete(id: number, customerId: string): Observable<boolean> {
    const url = `${this.apiUrl}/Delete`;
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("id", id.toString()).append("customerid", customerId)
    }
    return this.http.delete<boolean>(url, options);
  }

  public run(model: FtpDataSourceImportJobSettings): Observable<boolean> {
    const url = `${this.apiUrl}/Run`;
    return this.http.post<boolean>(url, model);
  }
}
